import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "~/const";
import { getLink } from "~/providers/lang";

export default function RedirectHomePage() {
	const navigation = useNavigate();

	useEffect(() => {
		navigation(getLink(ROUTES.home));
	}, []);

	return null;
}
